import { AvailabilityStatusAfterCancelEnum } from '../shared/models/availabilityStatusEnum';
import { CancelReason } from '../shared/models/cancelReason';

export const jobCanceledCancelReason = {
  id: 'JOB_CANCELED',
  displayName: {
    de: 'Dienst storniert',
    en: 'Job cancelled',
    fr: 'Service annulé',
  },
  statusAfterCancel: AvailabilityStatusAfterCancelEnum.UNKNOWN,
};
export const inviteesCancelledCancelReason = {
  id: 'INVITEES_CANCELED',
  displayName: {
    de: 'Alles Personal storniert',
    en: 'All personnel canceled',
    fr: 'Tout le personnel annulé',
  },
  statusAfterCancel: AvailabilityStatusAfterCancelEnum.UNKNOWN,
};
export const canceledArchivedJobCancelReason = {
  id: 'CANCELED_ARCHIVED_JOB',
  displayName: {
    de: 'Archivierter Dienst Storniert',
    en: 'Archived job canceled',
    fr: 'Service archivé annulé',
  },
  statusAfterCancel: AvailabilityStatusAfterCancelEnum.UNKNOWN,
};
export const retractedJobRequestCancelReason = {
  id: 'RETRACTED_JOB_REQUEST',
  displayName: {
    de: 'Dienstanfrage wurde zurückgezogen',
    en: 'Job request retracted',
    fr: "demande d'emploi rétractée",
  },
  statusAfterCancel: AvailabilityStatusAfterCancelEnum.AVAILABLE,
};
export const inviteeReplacedCancelReason = {
  id: 'INVITEE_REPLACED',
  displayName: {
    de: 'Mitarbeiter wurde ersetzt',
    en: 'Invitee was replaced',
    fr: 'invité remplacé',
  },
  statusAfterCancel: AvailabilityStatusAfterCancelEnum.UNKNOWN,
};
export const inviteeTransferredCancelReason = {
  id: 'INVITEE_TRANSFERRED',
  displayName: {
    de: 'Mitarbeiter wurde umgebucht',
    en: 'Invitee was transferred',
    fr: 'invité transféré',
  },
  statusAfterCancel: AvailabilityStatusAfterCancelEnum.UNKNOWN,
};
export const inviteeCancelledViaApiCancelReason = {
  id: 'INVITEE_CANCELLED_VIA_API',
  displayName: {
    de: 'Mitarbeiter wurde per Schnittstelle storniert',
    en: 'Invitee was canceled via API',
    fr: 'invité annulé via API',
  },
  statusAfterCancel: AvailabilityStatusAfterCancelEnum.UNKNOWN,
};

export const systemCancelReasons: CancelReason[] = [
  jobCanceledCancelReason,
  inviteesCancelledCancelReason,
  canceledArchivedJobCancelReason,
  retractedJobRequestCancelReason,
  inviteeReplacedCancelReason,
  inviteeTransferredCancelReason,
  inviteeCancelledViaApiCancelReason,
];

export const defaultCancelReasons: CancelReason[] = [
  {
    id: 'SICKNESS',
    displayName: { de: 'Krankheit', en: 'Illness', fr: 'Maladie' },
    statusAfterCancel: AvailabilityStatusAfterCancelEnum.UNAVAILABLE,
  },
  {
    id: 'ACCIDENT',
    displayName: { de: 'Unfall', en: 'Accident', fr: 'Accident' },
    statusAfterCancel: AvailabilityStatusAfterCancelEnum.UNAVAILABLE,
  },
  {
    id: 'OTHER_PERSONNEL',
    displayName: {
      de: 'Kunde hat anderes Personal gefunden',
      en: 'Customer found other personnel',
      fr: 'Le client a trouvé un autre personnel',
    },
    statusAfterCancel: AvailabilityStatusAfterCancelEnum.AVAILABLE,
  },
  {
    id: 'OTHER_REASON',
    displayName: {
      de: 'Anderer Grund',
      en: 'Other reason',
      fr: 'Autre raison',
    },
    enableDescription: true,
    statusAfterCancel: AvailabilityStatusAfterCancelEnum.UNKNOWN,
  },
  {
    id: 'PERSONNEL_DECLINED',
    displayName: {
      de: 'Personal abgelehnt',
      en: 'Personnel declined',
      fr: 'Personnel refusé',
    },
    statusAfterCancel: AvailabilityStatusAfterCancelEnum.UNAVAILABLE,
  },
  {
    id: 'CUSTOMER_DECLINED',
    displayName: {
      de: 'Kunde hat abgesagt',
      en: 'Customer canceled',
      fr: 'Client a annulé',
    },
    statusAfterCancel: AvailabilityStatusAfterCancelEnum.AVAILABLE,
  },
  {
    id: 'CREATION_MISTAKE',
    displayName: {
      de: 'Dienst falsch erfasst',
      en: 'Service incorrectly recorded',
      fr: 'Service mal saisi',
    },
    statusAfterCancel: AvailabilityStatusAfterCancelEnum.AVAILABLE,
  },
  {
    id: 'NOT_NEEDED_ANYMORE',
    displayName: {
      de: 'Dienst wird nicht mehr benötigt',
      en: 'Service no longer needed',
      fr: 'Service n’est plus nécessaire',
    },
    statusAfterCancel: AvailabilityStatusAfterCancelEnum.AVAILABLE,
  },
  {
    id: 'REST_TIME_AFTER_7_WORKING_DAYS',
    displayName: {
      de: 'Ruhezeit nach 7 Arbeitstage nicht eingehalten',
      en: 'Rest time after 7 working days not observed',
      fr: 'Temps de repos après 7 jours de travail non respecté',
    },
    statusAfterCancel: AvailabilityStatusAfterCancelEnum.UNAVAILABLE,
  },
  {
    id: 'OTHER_JOB_OFFER',
    displayName: {
      de: 'Anderer Dienst angeboten',
      en: 'Other job offered',
      fr: 'Autre offre de service',
    },
    statusAfterCancel: AvailabilityStatusAfterCancelEnum.UNKNOWN,
  },
  {
    id: 'NO_CAPACITY',
    displayName: {
      de: 'Keine Kapazität',
      en: 'No capacity',
      fr: 'Pas de capacité',
    },
    statusAfterCancel: AvailabilityStatusAfterCancelEnum.UNKNOWN,
  },
];
